module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.agreement) ? _c('div', [(_vm.forbidden) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "acceptedAgreement"
  }, [_vm._v("This link is no longer valid. Please contact us if you require access.")])]) : _c('div', {
    staticClass: "container costAgreement"
  }, [_c('div', {
    staticClass: "printHeading"
  }, [(_vm.brand === 'pl') ? _c('img', {
    attrs: {
      "src": require("../../assets/pocketlegal.png"),
      "alt": "PocketLegal"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.brand === 'ie') ? _c('img', {
    attrs: {
      "src": require("../../assets/immiexperts.png"),
      "alt": "Immigration Experts"
    }
  }) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-6 col-sm-12"
  }, [_c('strong', [_vm._v("Agent Details")]), _c('br'), _vm._v(" "), (_vm.brand === 'pl') ? _c('div', [_vm._v("\n            PocketLegal Pty Ltd"), _c('br'), _vm._v("\n            Benjamin Kramer"), _c('br'), _vm._v("\n            benji@pocketlegal.com.au"), _c('br'), _vm._v("\n            MARA Registration No: 1386609"), _c('br'), _vm._v("\n            PocketLegal"), _c('br'), _vm._v("\n            162 Redfern Street, Redfern 2016, NSW Australia"), _c('br'), _vm._v("\n            Phone: (02) 8385 1451"), _c('br'), _vm._v("\n            ABN: 12 613 908 124"), _c('br'), _vm._v("\n            ACN: 613 908 124\n          ")]) : _vm._e(), _vm._v(" "), (_vm.brand === 'ie') ? _c('div', [_vm._v("\n            Immigration Experts Pty Ltd"), _c('br'), _vm._v("\n            Benjamin Kramer"), _c('br'), _vm._v("\n            benji@immiexperts.com.au"), _c('br'), _vm._v("\n            MARA Registration No: 1386609"), _c('br'), _vm._v("\n            Immigration Experts"), _c('br'), _vm._v("\n            162 Redfern Street, Redfern 2016, NSW Australia"), _c('br'), _vm._v("\n            Phone: (02) 9279 1289"), _c('br'), _vm._v("\n            ABN: 12 613 908 124"), _c('br'), _vm._v("\n            ACN: 613 908 124\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column col-6"
  }, [_c('strong', [_vm._v("Client")]), _c('br'), _vm._v(" "), (_vm.agreement.business) ? _c('span', [_vm._v(_vm._s(_vm.agreement.business)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.agreement.name) ? _c('span', [_vm._v(_vm._s(_vm.agreement.name)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.agreement.email) ? _c('span', [_vm._v(_vm._s(_vm.agreement.email)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.agreement.address) ? _c('span', [_vm._v(_vm._s(_vm.agreement.address)), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.agreement.phone) ? _c('span', [_vm._v(_vm._s(_vm.agreement.phone)), _c('br')]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("Date of issue: " + _vm._s(new Date(_vm.agreement.date).toDateString()) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "columns bg-gray",
    staticStyle: {
      "border": "1px solid #ccc",
      "padding": "1em",
      "margin": "1em 0 2em 0"
    }
  }, [_c('div', {
    staticClass: "column col-12 text-center h6"
  }, [_vm._v("\n          SERVICE CATEGORY"), _c('br'), _vm._v("\n          " + _vm._s(_vm.agreement.visatype) + "\n        ")])]), _vm._v(" "), _c('h3', {
    staticClass: "text-center"
  }, [_vm._v("Important Information for Clients")]), _vm._v("\n      The terms and conditions of this agreement are set out below. By signing below you are confirming that you have read and understood all the conditions before entering into the agreement. If you wish to seek independent legal advice about this agreement, you should do so before signing this agreement.\n      "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_vm._v("\n            I accept the quoted fees, have read and understood the terms and conditions below, and I agree to be bound by this agreement. " + _vm._s(_vm.brandname) + " will assume your agreement if you do not inform us to the contrary and continue to instruct us to act for you.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-12",
    staticStyle: {
      "padding-top": "2em"
    }
  }, [(!_vm.agreement.accepted) ? _c('button', {
    staticClass: "btn btn-primary",
    class: {
      'loading': _vm.loading
    },
    on: {
      "click": _vm.accept
    }
  }, [_vm._v("\n              Accept\n            ")]) : _vm._e(), _vm._v(" "), (_vm.agreement.accepted) ? _c('div', [_c('span', {
    staticClass: "label label-success"
  }, [_vm._v("Accepted on")]), _vm._v(" "), _c('p', [_c('small', [_vm._v(_vm._s(new Date(_vm.agreement.accepted_at).toDateString()))])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "costAgreementTable"
  }, [_c('div', {
    staticClass: "columns bg-gray costagreementHeader"
  }, [_c('div', {
    staticClass: "column col-6"
  }, [_vm._v("\n              Items\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-2 text-center hide-md"
  }, [_vm._v("\n              Quantity\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-2 hide-md"
  }, [_vm._v("\n              Fixed Fee\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-2 hide-md"
  }, [_vm._v("\n              Total "), (!_vm.agreement.no_gst) ? _c('span', [_vm._v("(incl. 10% GST)")]) : _vm._e()])]), _vm._v(" "), _vm._l((_vm.agreement.items), function(item) {
    return _c('div', [_c('div', {
      staticClass: "columns costagreementItems"
    }, [_c('div', {
      staticClass: "column col-6 col-sm-12 itemDescription"
    }, [_vm._v("\n                " + _vm._s(item.description) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "column col-2 col-sm-12 itemQuantity"
    }, [_vm._v("\n                " + _vm._s(item.quantity) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "column col-2 col-sm-12 itemCost"
    }, [_vm._v("\n                $" + _vm._s(_vm.c2d(item.cost)) + "\n              ")]), _vm._v(" "), _c('div', {
      staticClass: "column col-2 col-sm-12 itemTotal"
    }, [_vm._v("\n                $" + _vm._s(_vm.itemtotal(item)) + "\n              ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-10 hide-md"
  }, [_vm._v("\n              Total "), (!_vm.agreement.no_gst) ? _c('span', [_vm._v("(including GST)")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "column col-2 col-sm-12 itemTotalGst"
  }, [_c('strong', [_vm._v("$" + _vm._s(_vm.total))])])])], 2)]), _vm._v(" "), _c('h2', [_vm._v("Third Party Costs")]), _vm._v(" "), _c('p', [_vm._v("Below is a non-exhaustive list of potential 3rd party fees. We are not responsible for these fees, which are payable when due and are subject to vary at any time; these services are disbursements in addition to the fees of " + _vm._s(_vm.brandname) + ".")]), _vm._v(" "), _c('p', [_vm._v("Please review them carefully to determine the full cost of your application.")]), _vm._v(" "), _c('div', {
    staticClass: "costAgreementTable"
  }, [_vm._m(1), _vm._v(" "), (_vm.agreement.visatype === '482 - Primary (Short-Term Stream)') ? _c('div', [_vm._m(2)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Primary (Long-Term Stream)') ? _c('div', [_vm._m(3)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Primary') ? _c('div', [_vm._m(4)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Nomination') ? _c('div', [_vm._m(5), _vm._v(" "), _vm._m(6)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Nomination') ? _c('div', [_vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Sponsor') ? _c('div', [_vm._m(10), _vm._v(" "), _vm._m(11)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Sponsor') ? _c('div', [_vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Standard Business Sponsorship') ? _c('div', [_vm._m(15)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Subsequent Entrant') ? _c('div', [_vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Sponsorship and Primary') ? _c('div', [_vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Sponsorship and Primary') ? _c('div', [_vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '457 - Primary') ? _c('div', [_vm._m(25)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '457 - Nomination') ? _c('div', [_vm._m(26)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '457 - Sponsor') ? _c('div', [_vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '457 - Subsequent Entrant') ? _c('div', [_vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _vm._m(32)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '187 - Nomination') ? _c('div', [_vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _vm._m(37)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '187 - Primary') ? _c('div', [_vm._m(38), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _vm._v(" "), _vm._m(42)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '186 - Primary') ? _c('div', [_vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _vm._m(45), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47), _vm._v(" "), _vm._m(48)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '186 - Nomination') ? _c('div', [_vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51), _vm._v(" "), _vm._m(52)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '186 - Nomination and Primary') ? _c('div', [_vm._m(53), _vm._v(" "), _vm._m(54), _vm._v(" "), _vm._m(55), _vm._v(" "), _vm._m(56), _vm._v(" "), _vm._m(57), _vm._v(" "), _vm._m(58), _vm._v(" "), _vm._m(59), _vm._v(" "), _vm._m(60), _vm._v(" "), _vm._m(61), _vm._v(" "), _vm._m(62)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Protection') ? _c('div', [_vm._m(63)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Waiver') ? _c('div', [_vm._m(64)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Partner Visa') ? _c('div', [_vm._m(65), _vm._v(" "), _vm._m(66), _vm._v(" "), _vm._m(67)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '820 - Partner Visa') ? _c('div', [_vm._m(68), _vm._v(" "), _vm._m(69), _vm._v(" "), _vm._m(70)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '801 - Partner Visa') ? _c('div', [_vm._m(71), _vm._v(" "), _vm._m(72)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '300 - Prospective Marriage Visa') ? _c('div', [_vm._m(73), _vm._v(" "), _vm._m(74), _vm._v(" "), _vm._m(75)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Skilled Independent Visa') ? _c('div', [_vm._m(76), _vm._v(" "), _vm._m(77), _vm._v(" "), _vm._m(78), _vm._v(" "), _vm._m(79), _vm._v(" "), _vm._m(80), _vm._v(" "), _vm._m(81)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Tourist Visa') ? _c('div', [_vm._m(82), _vm._v(" "), _vm._m(83), _vm._v(" "), _vm._m(84), _vm._v(" "), _vm._m(85), _vm._v(" "), _vm._m(86)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '600 - Visitor Visa') ? _c('div', [_vm._m(87), _vm._v(" "), _vm._m(88), _vm._v(" "), _vm._m(89), _vm._v(" "), _vm._m(90), _vm._v(" "), _vm._m(91)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Student Visa') ? _c('div', [_vm._m(92), _vm._v(" "), _vm._m(93), _vm._v(" "), _vm._m(94), _vm._v(" "), _vm._m(95)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Student - Subsequent Entrant') ? _c('div', [_vm._m(96), _vm._v(" "), _vm._m(97), _vm._v(" "), _vm._m(98), _vm._v(" "), _vm._m(99)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '189 - NZ Stream') ? _c('div', [_vm._m(100), _vm._v(" "), _vm._m(101), _vm._v(" "), _vm._m(102), _vm._v(" "), _vm._m(103)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Ministerial Intervention') ? _c('div', [_vm._m(104), _vm._v(" "), _vm._m(105)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'AAT Appeal') ? _c('div', [_vm._m(106)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '408') ? _c('div', [_vm._m(107), _vm._v(" "), _vm._m(108)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '407') ? _c('div', [_vm._m(109), _vm._v(" "), _vm._m(110), _vm._v(" "), _vm._m(111), _vm._v(" "), _vm._m(112), _vm._v(" "), _vm._m(113), _vm._v(" "), _vm._m(114), _vm._v(" "), _vm._m(115), _vm._v(" "), _vm._m(116), _vm._v(" "), _vm._m(117)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '407 - Sponsor') ? _c('div', [_vm._m(118), _vm._v(" "), _vm._m(119)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '485 - Graduate Visa') ? _c('div', [_vm._m(120), _vm._v(" "), _vm._m(121)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Citizenship') ? _c('div', [_vm._m(122)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Distinguished Talent Visa') ? _c('div', [_vm._m(123)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '802 - Child Visa') ? _c('div', [_vm._m(124), _vm._v(" "), _vm._m(125)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Contributory Parent Visa') ? _c('div', [_vm._m(126), _vm._v(" "), _vm._m(127), _vm._v(" "), _vm._m(128)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '461 - NZ Citizen Family Relationship') ? _c('div', [_vm._m(129), _vm._v(" "), _vm._m(130)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Resident Return Visa') ? _c('div', [_vm._m(131)]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Medical Treatment Visa') ? _c('div', [_vm._m(132)]) : _vm._e()]), _vm._v(" "), _c('h2', [_vm._v("TERMS AND CONDITIONS OF SERVICE ")]), _vm._v(" "), _c('p', [_vm._v("As soon as possible after giving instructions to the Agent and receiving an estimate of fees, disbursements and the likely time to be taken in performing services, the Client will provide written acceptance of these estimates. ")]), _vm._v(" "), _c('h3', [_vm._v("1. Appointment of an agent")]), _vm._v(" "), _vm._m(133), _vm._v(" "), _c('h3', [_vm._v("2. Code of Conduct ('The Code')")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("The Code is intended to regulate the conduct of registered migration agents by introducing a proper standard for the conduct of business as a registered migration agent and establishes the minimum attributes and abilities that a person must demonstrate to perform as a registered migration agent. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent guarantees to provide a copy of the Code to the Client immediately upon request. The Client acknowledges that they are aware of and have read the Consumer Guide, which, along with the Code, is available at "), (_vm.brand === 'pl') ? _c('div', [_c('a', {
    attrs: {
      "href": "https://pocketlegal.com.au/resources/the-code",
      "target": "new"
    }
  }, [_vm._v("https://pocketlegal.com.au/resources/the-code")])]) : _vm._e(), (_vm.brand === 'ie') ? _c('div', [_c('a', {
    attrs: {
      "href": "http://www.immiexperts.com.au/wp-content/uploads/2018/11/Code_of_Conduct_April_2017.pdf"
    }
  }, [_vm._v("http://www.immiexperts.com.au/wp-content/uploads/2018/11/Code_of_Conduct_April_2017.pdf")])]) : _vm._e(), _vm._v(".")]), _vm._v(" "), _c('li', [_vm._v("If the Code (which is prescribed in Schedule 2 of the Migration Agent Regulations 1998) is inconsistent with this agreement, the Agent and Client agree to vary this agreement to the extent that it complies with the new Code. ")])]), _vm._v(" "), _c('h3', [_vm._v("3. Services to be provided")]), _vm._v(" "), _vm._m(134), _vm._v(" "), _c('h3', [_vm._v("4. The agent guarantees that")]), _vm._v(" "), _vm._m(135), _vm._v(" "), _c('h3', [_vm._v("5. The parties agree")]), _vm._v(" "), _vm._m(136), _vm._v(" "), _c('h3', [_vm._v("6. Termination of agreement")]), _vm._v(" "), _vm._m(137), _vm._v(" "), _c('h3', [_vm._v("7. Retention of documents")]), _vm._v(" "), _vm._m(138), _vm._v(" "), _c('h3', [_vm._v("8. Confidentiality")]), _vm._v(" "), _vm._m(139), _vm._v(" "), _c('h3', [_vm._v("9. Conflicts of Interest")]), _vm._v(" "), _vm._m(140), _vm._v(" "), _c('h3', [_vm._v("10. Electronic communications")]), _vm._v(" "), _vm._m(141), _vm._v(" "), _c('h3', [_vm._v("11. Relevant law and jurisdiction")]), _vm._v(" "), _vm._m(142), _vm._v(" "), _c('h3', [_vm._v("12. Unpaid accounts")]), _vm._v(" "), _vm._m(143), _vm._v(" "), _c('h2', [_vm._v("SCHEDULE OF FEES")]), _vm._v(" "), _c('h3', [_vm._v("1. Fee types")]), _vm._v(" "), _c('p', [_vm._v("a) Fixed Fee")]), _vm._v(" "), _vm._m(144), _vm._v(" "), _c('p', [_vm._v("b) Hourly Rates")]), _vm._v(" "), _vm._m(145), _vm._v(" "), _vm._m(146), _vm._v(" "), _c('h3', [_vm._v("2. Payment terms")]), _vm._v(" "), _c('ol', [(_vm.brand === 'pl') ? _c('span', [_c('li', [_vm._v("We require an initial deposit of $700 (plus GST) to cover the cost of our initial research and advice, and to commence preparation of your visa application.")])]) : _vm._e(), _vm._v(" "), (_vm.brand === 'ie') ? _c('span', [_c('li', [_vm._v("We require an initial deposit of 50% of our professional fees to cover the cost of our initial research and advice, and to commence preparation of your visa application.")])]) : _vm._e(), _vm._v(" "), _c('li', [_vm._v("The remaining balance of your account will be invoiced at least 2 weeks prior to the lodgement of your application.")]), _vm._v(" "), _c('li', [_vm._v("Immigration matters can take many months to resolve, we may invoice you from time to time for work done to the date of the invoice.")]), _vm._v(" "), _c('li', [_vm._v("The Agent's professional fees can be invoiced on behalf of the Agent by the Agent's business entity, as listed on the MARA Register of Migration Agents. ")]), _vm._v(" "), _c('li', [_vm._v("Agent is not liable for delays in accounting if the Client fails to identify the payments appropriately and/or provide written confirmation of any payments made as soon as possible. ")])]), _vm._v(" "), _c('h3', [_vm._v("3. Disbursements")]), _vm._v(" "), _vm._m(147), _vm._v(" "), _c('h3', [_vm._v("4. Payment methods")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Payment should be made within 14 days upon receipt of invoice, via the " + _vm._s(_vm.brandname) + " website payment facility (credit card payment), or direct bank deposit where relevant.")]), _vm._v(" "), _c('li', [_vm._v("You are responsible for all banking fees and currency conversion costs. Please ensure the full amount invoiced reaches our account in Australia within the time specified and appropriately labeled to prevent additional administration fees.")])]), _vm._v(" "), _c('h3', [_vm._v("Processing Times")]), _vm._v(" "), _c('p', [_vm._v("Once applications have been lodged by " + _vm._s(_vm.brandname) + " with the DHA you can expect the following processing times. Your agent will speak with you about bridging or other visas to accommodate a stay in Australia during processing time if relevant.")]), _vm._v(" "), _c('div', {
    staticClass: "costAgreementTable"
  }, [_vm._m(148), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-6"
  }, [_vm._v("\n                " + _vm._s(_vm.agreement.visatype) + "\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-6"
  }, [(_vm.agreement.visatype === '482 - Primary (Short-Term Stream)') ? _c('span', [_vm._v("3 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Primary (Long-Term Stream)') ? _c('span', [_vm._v("3 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Nomination') ? _c('span', [_vm._v("3 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Sponsor') ? _c('span', [_vm._v("3 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '482 - Sponsorship and Primary') ? _c('span', [_vm._v("1 - 3 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '457 - Primary') ? _c('span', [_vm._v("3 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '457 - Nomination') ? _c('span', [_vm._v("3 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '457 - Sponsor') ? _c('span', [_vm._v("3 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Skilled Independent Visa') ? _c('span', [_vm._v("6 - 12 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '186 - Primary') ? _c('span', [_vm._v("11 - 14 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '186 - Nomination') ? _c('span', [_vm._v("11 - 14 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '186 - Nomination and Primary') ? _c('span', [_vm._v("11 - 14 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '187 - Primary') ? _c('span', [_vm._v("6 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '187 - Nomination') ? _c('span', [_vm._v("22 - 25 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Partner Visa') ? _c('span', [_vm._v("15 - 24 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '801 - Partner Visa') ? _c('span', [_vm._v("18 - 25 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '820 - Partner Visa') ? _c('span', [_vm._v("15 - 24 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '300 - Prospective Marriage Visa') ? _c('span', [_vm._v("12 - 16 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Resident Return Visa') ? _c('span', [_vm._v("5 - 12 days")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Student Visa') ? _c('span', [_vm._v("14 days - 3 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Student - Subsequent Entrant') ? _c('span', [_vm._v("21 - 45 days")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '600 - Visitor Visa') ? _c('span', [_vm._v("1 day - 1 month")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Tourist Visa') ? _c('span', [_vm._v("1 day - 1 month")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Ministerial Intervention') ? _c('span', [_vm._v("3 - 12 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '189') ? _c('span', [_vm._v("5 - 8 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '189 - NZ Stream') ? _c('span', [_vm._v("4 - 9 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '485 - Graduate Visa') ? _c('span', [_vm._v("3 - 4 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '407') ? _c('span', [_vm._v("66 - 80 days")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '407 - Sponsor') ? _c('span', [_vm._v("66 - 80 days")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '408') ? _c('span', [_vm._v("2 - 65 days")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '461 - NZ Citizen Family Relationship') ? _c('span', [_vm._v("11 - 15 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === '802 - Child Visa') ? _c('span', [_vm._v("11 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Distinguished Talent Visa') ? _c('span', [_vm._v("Processing times vary")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Contributory Parent Visa') ? _c('span', [_vm._v("40 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'AAT Appeal') ? _c('span', [_vm._v("12 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Protection') ? _c('span', [_vm._v("18 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Waiver') ? _c('span', [_vm._v("1 - 4 months")]) : _vm._e(), _vm._v(" "), (_vm.agreement.visatype === 'Medical Treatment Visa') ? _c('span', [_vm._v("30 - 60 days")]) : _vm._e()])])]), _vm._v(" "), _vm._m(149)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "costAgreementHeader"
  }, [_c('h1', [_vm._v("Cost Agreement")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns bg-gray"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Item")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Cost")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Third Party")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thirdParties"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 Visa Primary Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,150")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Dependant (over 18) Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,150")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Dependant (under 18) Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$290")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("English test (if applicable)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers, eg IELTS, PTE")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)  ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Health Insurance")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Differs by provider")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thirdParties"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 Visa Primary Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$2,400")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Dependant (over 18) Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$2,400")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Dependant (under 18) Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$600")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("English test (if applicable)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers, eg IELTS, PTE")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)  ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Health Insurance")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Differs by provider")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thirdParties"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 Visa Primary Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,150 - $2,400"), _c('br'), _vm._v("Depending on occupation stream")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Dependant (over 18) Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,150 - $2,400"), _c('br'), _vm._v("Depending on occupation stream")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Dependant (under 18) Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$290 - $600"), _c('br'), _vm._v("Depending on occupation stream")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("English test (if applicable)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers, eg IELTS, PTE")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)  ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Health Insurance")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Differs by provider")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 Nomination Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Training Levy"), _c('br'), _vm._v("\n            Businesses with annual turnover under $10mil")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,200"), _c('br'), _vm._v("(per number of years the visa is required)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of less than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1200"), _c('br'), _vm._v("(per number of years visa is required)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_vm._v("\n            OR\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of more than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1800"), _c('br'), _vm._v("(per number of years visa is required)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 Standard Business Sponsorship Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$420")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 Nomination Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of less than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1200"), _c('br'), _vm._v("(per number of years visa is required)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_vm._v("\n            OR\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of more than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1800"), _c('br'), _vm._v("(per number of years visa is required)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 - Standard Business Sponsorship Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$420")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 Subsequent Entrant Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,150 - $2,400")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Health Insurance")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Differs by provider")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 Standard Business Sponsorship Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$420")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 Nomination Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("482 Primary Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,150 - $2,400"), _c('br'), _vm._v("Depending on occupation stream")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of less than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1200"), _c('br'), _vm._v("(per number of years visa is required)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_vm._v("\n            OR\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of more than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1800"), _c('br'), _vm._v("(per number of years visa is required)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thirdParties"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("457 Visa Primary Application")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1060")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Dependant (over 18) Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1060")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Dependant (under 18) Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$265")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("English test (if applicable)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers, eg IELTS, PTE")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)  ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Health Insurance")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Differs by provider")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("457 Nomination Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("457 Nomination Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("457 Standard Business Sponsorship Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$420")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Training Benchmarks")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("1 - 2% annual payroll")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("457 Subsequent Entrant Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,080")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Health Insurance")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Differs by provider")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("187 Visa Nomination Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$540")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("RCB Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$600 - $2000")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various Regional Bodies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of less than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$3,000")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_vm._v("\n            OR\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of more than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$5,000")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("187 Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$3,670")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("186 Visa Application Fee"), _c('br'), _vm._v("Dependant Over 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,800")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("186 Visa Application Fee"), _c('br'), _vm._v("Dependant Under 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$900")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("English test (if applicable)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers, eg IELTS, PTE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("186 Visa Primary Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$3,670")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("186 Visa Application Fee"), _c('br'), _vm._v("Dependant Over 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,800")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("186 Visa Application Fee"), _c('br'), _vm._v("Dependant Under 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$900")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Skills Assessment")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$750-900")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("English test (if applicable)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers, eg IELTS, PTE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("186 Visa Nomination Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$540")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of less than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$3,000")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_vm._v("\n            OR\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of more than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$5,000")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("186 Visa Nomination Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$540")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of less than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$3,000")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns",
    staticStyle: {
      "border-bottom": "none"
    }
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_vm._v("\n              OR\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Nomination Training Contribution Charges for a business with an Annual Turnover of more than $10 million")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$5,000")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Skilling Australians Fund (SAF)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("186 Visa Primary Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$3,670")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("186 Visa Application Fee"), _c('br'), _vm._v("Dependant Over 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,800")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("186 Visa Application Fee"), _c('br'), _vm._v("Dependant Under 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$900")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Skills Assessment (if applicable)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$750-900")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("English test (if applicable)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers, eg IELTS, PTE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Protection Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$35")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Protection Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$35")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Partner Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$7,160")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation (where relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Partner Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$7,160")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation (where relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation (where relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Partner Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$7,160")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation (where relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Skilled Independent Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$3,600")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Skilled Independent Visa Application Fee"), _c('br'), _vm._v("Dependant Over 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,800")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Skilled Independent Visa Application Fee"), _c('br'), _vm._v("Dependant Under 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$900")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Skills Assessment")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$750-900")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation (where relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Visitor Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$140")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Visitor Visa "), _c('em', [_vm._v("Frequent Traveller Stream")]), _vm._v(" Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,020")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Visitor Visa "), _c('em', [_vm._v("Where Applicant is in Australia")]), _vm._v(" Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,020")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Medical check (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Varies")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Visitor Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$140")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Visitor Visa "), _c('em', [_vm._v("Frequent Traveller Stream")]), _vm._v(" Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,020")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Visitor Visa "), _c('em', [_vm._v("Where Applicant is in Australia")]), _vm._v(" Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,020")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Medical check (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Varies")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Student Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$560")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Student Visa Application Fee"), _c('br'), _vm._v("Dependant Over 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$420")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Student Visa Application Fee"), _c('br'), _vm._v("Dependant Under 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$140")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Subsequent Temporary Application Charge (Applicable to each applicant) - Relevant when applying for a second temporary visa onshore")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$700")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Subsequent Entrant Student Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$560")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Student Visa Application Fee"), _c('br'), _vm._v("Dependant Over 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$420")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Student Visa Application Fee"), _c('br'), _vm._v("Dependant Under 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$140")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Subsequent Temporary Application Charge (Relevant when applying for a second temporary visa onshore)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$700")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("189 Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$3670")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("189 Visa Application Fee"), _c('br'), _vm._v("Dependant Over 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1800")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("189 Visa Application Fee"), _c('br'), _vm._v("Dependant Under 18 (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$900")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Medical check (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Varies")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Document Translation (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$30 per page")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Translation Service")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1,731 (50% returned if appeal succeeds)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Administrative Appeals Tribunal (AAT)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("408 Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$280")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("English test (if applicable)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers, eg IELTS, PTE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("407 Visa Sponsorship Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$420")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("407 Visa Nomination Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$170")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("407 Visa Primary Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$285")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("407 Visa Application Fee (dependant over 18)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$285")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("407 Visa Application Fee (dependant under 18)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$70")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("English test (if applicable)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$330")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers, eg IELTS, PTE")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Medical check (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Varies")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Health Insurance")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("Differs by provider")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("407 Sponsorship Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$420")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("407 Nomination Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$170")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("485 Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$1470")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Skills Assessment (if relevant)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$900")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various Providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Citizenship Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$285")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Distinguished Talent Visa")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$3,310")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("802 Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$2,415")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Contributory Parent Visa Application Fee")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$19,750")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Medical check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_c('em', [_vm._v("Differs by provider")])]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Various Providers")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("461 - NZ Citizen Family Relationship")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$340")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Penal check(s)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$42 ~")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("Australian Federal Police & overseas police")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Resident Return visa (subclasses 155 & 157)")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$375")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-5"
  }, [_vm._v("Medical Treatment Visa")]), _vm._v(" "), _c('div', {
    staticClass: "column col-3"
  }, [_vm._v("$290")]), _vm._v(" "), _c('div', {
    staticClass: "column col-4"
  }, [_vm._v("DHA")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("The Client appoints the Agent to represent the Client and to perform the services described in this agreement.")]), _vm._v(" "), _c('li', [_vm._v("The Client acknowledges and consents to administrative services being provided by other staff. The Responsible Agent will properly supervise the work carried out by any staff working for the Agent. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("Provide advice relating to the Client's migration goals and choice of visa category ")]), _vm._v(" "), _c('li', [_vm._v("Provide frank and candid advice regarding the prospects of success. An agent cannot guarantee the success of an application")]), _vm._v(" "), _c('li', [_vm._v("Analyse current Immigration Law relating to the nominated visa category or review application (may incur hourly fee)")]), _vm._v(" "), _c('li', [_vm._v("Assist in the completion and/or checking of relevant application forms")]), _vm._v(" "), _c('li', [_vm._v("Provide advice and assistance relating to documentation required to support the application ")]), _vm._v(" "), _c('li', [_vm._v("Prepare any necessary supporting submissions to the relevant Assessing Authority, Department or review body (may incur hourly fee)")]), _vm._v(" "), _c('li', [_vm._v("Submit the application to the relevant Assessing Authority, Department or review body for processing as soon as possible ")]), _vm._v(" "), _c('li', [_vm._v("Wherever possible, supply any further documentation or information requested by the Department on receipt of documents from the Client")]), _vm._v(" "), _c('li', [_vm._v("Wherever possible, assist the Client to comply with any request made by the Department or review body. ")]), _vm._v(" "), _c('li', [_vm._v("Keep the Client fully informed of all developments concerning the progress of the application")]), _vm._v(" "), _c('li', [_vm._v("Promptly advise the Client of any communications from the Department or review body")]), _vm._v(" "), _c('li', [_vm._v("During the processing of the application, advise the Client of any changes to the law affecting the visa application")]), _vm._v(" "), _c('li', [_vm._v("Advise the Client promptly of the outcome of the application")]), _vm._v(" "), _c('li', [_vm._v("Provide post-grant migration advice regarding visa conditions and requirements ")]), _vm._v(" "), _c('li', [_vm._v("The fixed fee does not include additional work required to resolves issues relating to character such as criminal convictions, health or provision of unsuitable documents or documents suspected of being false. If such issues arise, additional fees will be payable at the rate specified above or at an agreed fixed fee.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("The Agent is registered with the Migration Agents Registration Authority. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent maintains the required level of Professional Indemnity Insurance. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent has no conflict of interest in terms of Part 2 of the Code. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent will act in accordance with the law and in the best interests of the Client, and deal with the Client competently, diligently and fairly. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent has sufficient knowledge of the relevant laws to be able to provide the agreed services. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent will advise the Client in writing, if in the Agent's opinion, the application is vexatious or grossly unfounded. ")]), _vm._v(" "), _c('li', [_vm._v("Will, on request, provide the Client with a copy of their application and any related documents unless accounts are outstanding ($0.50 per page).")]), _vm._v(" "), _c('li', [_vm._v("No legal advice will be provided unless in accordance with a separate cost agreement.")]), _vm._v(" "), _c('li', [_vm._v("Clients may have access to an interpreter if requested and at their own expense. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("The Agent is able to advise the Client about immigration law at a particular point in time but is unable to predict future changes in the law or to individual circumstances. ")]), _vm._v(" "), _c('li', [_vm._v("The Client will respond promptly to requests by the Agent for further information or documents as necessary.")]), _vm._v(" "), _c('li', [_vm._v("The Client will not hold the Agent responsible for delays caused by the Client's failure to promptly provide information or documents. The Client is aware that failure to provide documents as required is likely to lead to an application being refused. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent will be under no obligation to submit the Client's application to the Department or review body until payment has been made in full of all fees due and payable at that stage. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent will provide the Client with a copy of the booklet titled Information on the Regulation of the Migration Advice Profession upon request. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent cannot guarantee the success of any application under any circumstance or at any stage or that the application will be approved by a specific date or within a specific period. ")]), _vm._v(" "), _c('li', [_vm._v("The final decision on an application submitted to DIAC is beyond the Agent's control. The Agent is under no obligation to provide any refund should the application be refused for reasons outside the Agent's control. ")]), _vm._v(" "), _c('li', [_vm._v("The Client bears the risk that changes in immigration law or their personal circumstances may cause an application to no longer be appropriate. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent will not be liable for any loss arising from changes to the law affecting the Client's application. The Agent cannot predict changes in the law and will not be responsible if applications are affected as a result.")]), _vm._v(" "), _c('li', [_vm._v("The Client will not sell property, leave employment or finalise any business or personal affairs without first notifying the Agent of any material change.")]), _vm._v(" "), _c('li', [_vm._v("All information provided to the Agent is, to the best of the Client's knowledge and belief, true and current and that all documents supplied are genuine and authentic. The Client is aware that the provision of false information or documents is likely to lead to an application being refused. ")]), _vm._v(" "), _c('li', [_vm._v("The Client will, during the processing of an application, notify the Agent of any material changes in the circumstances of the Client or the Client's immediate family. If the application is for an employer-sponsored visa, the Client agrees that they will take no other employment apart from the employment that is the subject of the sponsorship agreement. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent's professional fees can be invoiced on behalf of the Agent by the Agent's business entity, as listed on the MARA Register. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent will not be held responsible for any consequential issues resulting from a failure to deposit cleared funds into the Agent's trust account when requested. This includes transfer failures, delayed transfers and payment failures. The Client is aware that failure to make prompt payments to the Department, review body or skills assessment body may lead to\n          an application being refused. ")]), _vm._v(" "), _c('li', [_vm._v("The Client will not contact DIAC directly. The Client will notify the Agent if they are contacted by DIAC in relation to this or any other matter. The Client agrees that the Agent is the sole contact with the Department and the Client will not contact the Department without agreement from the Agent. ")]), _vm._v(" "), _c('li', [_vm._v("The Client will advise the Agent of any change of contact details within two weeks of the change. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("The Client may terminate this agreement by providing written advice of the termination to the Agent. ")]), _vm._v(" "), _c('li', [_vm._v("The Agent may terminate the agreement at any time, provided they provide reasonable written notice to the Client. This notice\n            must comply with the requirements in Clause 10.1A of the Code. If the Agent terminates the agreement, they must comply with\n            the requirements of Clause 10.1B of the Code. ")]), _vm._v(" "), _c('li', [_vm._v("If the agreement is terminated, the Client must pay any fees outstanding for work already performed by the Agent. ")]), _vm._v(" "), _c('li', [_vm._v("When the agreement is terminated, the Agent must deal with the Client's file in accordance with Part 10 of the Code. ")]), _vm._v(" "), _c('li', [_vm._v("The Client agrees that if the Client breaches this agreement, the Agent has the right to terminate the contract and invoice for full fees as per the cost arrangement, or in the alternative, the Agent has the right to charge hourly fees at the rate of $400 per hour for any additional services required as a result of the breach.")]), _vm._v(" "), _c('li', [_vm._v("The Client is entitled to a five working day Cooling Off period from the date this agreement is signed, within which they can withdraw the Agent's services. The Agent will reimburse the entire initial amount after deducting any administrative costs or professional fees for the time spent on the visa application within that time frame. After the Cooling Off period, no refund applies and the Agent is considered as appointed by the Client. After this time however, no refunds will be provided, including if the Agent determines that the Client is ineligible to apply for any visa.")]), _vm._v(" "), _c('li', [_vm._v("If this Agreement is handed, emailed, posted or otherwise delivered to the Client and the Client does not sign the Agreement and return it to the Agent, the Client will nonetheless be taken to have accepted its terms and conditions if the Client does not notify the Agent within 21 days of any concern the Client may have or otherwise permits work by the Agent to be commenced or continued in relation to the subject matter of the Agreement.")]), _vm._v(" "), _c('li', [_vm._v("Only under the circumstances that the Client's visa application is rejected by the DHA, due to a mistake on part of the Agent, a refund of Agent's professional fee after deducting reasonable administrative costs will be reimbursed to the Client.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("The Agent agrees to keep securely and in a way which will ensure confidentiality all documents provided by, or on behalf of, the Client or paid for by, or on behalf of, the Client until the earlier of:\n            ")]), _vm._v(" "), _c('li', [_vm._v("(i) 7 years after the date of the last action on the file for the Client; or")]), _vm._v(" "), _c('li', [_vm._v("(ii) when the documents are given to the Client or dealt with in accordance with the Client's written instructions.")]), _vm._v(" "), _c('li', [_vm._v("The Agent agrees to keep all other records required by Clause 6.1 of the Code for 7 years after the date of the last action on the file for the Client. ")]), _vm._v(" "), _c('li', [_vm._v("After this date the Agent may destroy the documents and records above in a way which will ensure confidentiality. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("The Agent will preserve the confidentiality of the Client. The Agent will not disclose confidential information about the Client or the Client's business without the Client's written consent, unless required by law. ")]), _vm._v(" "), _c('li', [_vm._v("If applicable, the Agent will preserve the confidentiality of the Client's medical records and documents in accordance with the Privacy Act.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("The Client, after making diligent inquiry, at the date of signing this Contract agrees that no Conflict exists or is likely to arise in the performance of obligations under this Contract by the Agent or the Agent's employees, or if a Conflict does exist that Conflict has been disclosed to the Agent in writing prior to the date of signing of this Contract.")]), _vm._v(" "), _c('li', [_vm._v("The Agent will endeavour to avoid Conflicts but is permitted to use its discretion when collecting or revealing information to any third party, unless the Client notifies the Agent in writing that such information is confidential.")]), _vm._v(" "), _c('li', [_vm._v("If any Conflict or potential Conflict arises or becomes apparent, the Client will provide written notice to the Agent without unreasonable delay and the Agent will cease acting for one or both parties at its discretion.")]), _vm._v(" "), _c('li', [_vm._v("The Agent will notify the parties if a potential Conflict has arisen without unreasonable delay.")]), _vm._v(" "), _c('li', [_vm._v("The Agent is otherwise bound by the MARA Code of Conduct with respect to Conflicts.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("The Agent disclaims and waives any liability or responsibility whatsoever for interception or unintentional disclosure of emails transmitted by the Agent, or through correspondence and personal documentation being temporarily stored on any 3rd party servers.")]), _vm._v(" "), _c('li', [_vm._v("The Client agrees that the Agent shall bear no liability for any loss or damage to any person or entity resulting from the use of email transmissions, including any consequential, incidental, direct, indirect, or special damages, such as loss of revenues or anticipated profits, or disclosure or communication of confidential or proprietary information. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("These conditions and all aspects of the performance of our services for you are governed by, and you agree to be bound by, the law of the NSW and the Code of Conduct. The Client and Agent irrevocably submit to the exclusive jurisdiction of the courts of the NSW and/or the Migration Agents Registration Authority.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("If an account remains unpaid thirty (30) days after you receive it, we may charge you interest at 2% above the Cash Rate.")]), _vm._v(" "), _c('li', [_vm._v("If the Client does not pay the account within the time frame listed in the Schedule, the Agent may stop work until paid. If the account continues to remain unpaid the Agent may cease to act for the Client.")]), _vm._v(" "), _c('li', [_vm._v(" If the Agent stops acting or ceases to act for the Client:\n            ")]), _vm._v(" "), _c('li', [_vm._v("The Agent will not incur any liability as a result.")]), _vm._v(" "), _c('li', [_vm._v("The Client will receive a final account, which will include all outstanding fees.")]), _vm._v(" "), _c('li', [_vm._v("The Client must pay the Agent's legal costs up until the date when the Agent ceased to act.")]), _vm._v(" "), _c('li', [_vm._v("The Agent retains the right to exercise a lien over the Client's documents until the Agent is paid.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("This fee is calculated based on your instructions. If at a later date, these instructions change, new information is provided, or your circumstances change with the result that there is a substantial increase in the amount of work to be performed, then we reserve the right to ask for additional fees.")]), _vm._v(" "), _c('li', [_vm._v("If you decide at any stage to withdraw the application or decide that you do not wish us to be your Migrant Agent, we will charge you a reasonable fee for the work we have completed up until that point. Disbursement fees are generally not refundable.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("Our fixed price quote represents a discounted scale fee for an average application. We will keep you informed of progress on your application, however, should you delay the application, not provide the information as required, or unnecessarily and continually have further queries we reserve the right to charge an additional time based fee which we will notify you of at that time. Hourly rates will be charged as per the figures below.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "costAgreementTable"
  }, [_c('div', {
    staticClass: "columns bg-gray"
  }, [_c('div', {
    staticClass: "column col-12"
  }, [_vm._v("\n                Hourly Rates"), _c('br'), _vm._v(" "), _c('em', [_vm._v("Only incurred upon request. Fees are inclusive of GST.")])])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-6 col-sm-7"
  }, [_vm._v("\n                Solicitor / Migration Lawyer\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-6 col-sm-5"
  }, [_vm._v("\n                $330 / hour\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-6 col-sm-7"
  }, [_vm._v("\n                Migration Agent\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-6 col-sm-5"
  }, [_vm._v("\n                $165 / hour\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column col-6 col-sm-7"
  }, [_vm._v("\n                Legal Clerk\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-6 col-sm-5"
  }, [_vm._v("\n                $110 / hour\n              ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ol', [_c('li', [_vm._v("Other costs that are often incurred when applying for a visa are listed above.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns bg-gray"
  }, [_c('div', {
    staticClass: "column col-6"
  }, [_vm._v("\n                Visa Type\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "column col-6"
  }, [_vm._v("\n                Processing Time\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "consumerGuide"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/consumer_guide.gif"),
      "alt": "Consumer Guide"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cab34db"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/agreements/agreement.vue
// module id = 507
// module chunks = 1